// NotificationPopup.jsx
import React from 'react';
import ReactDOM from 'react-dom';
import Button from './widgets/button';
import CloseIconBlack from '../static/images/black_icons/x_icon_black.png';
import CloseIconWhite from '../static/images/x_icon.png';
import { useTheme } from '../theme/ThemeContext';

const NotificationPopup = ({ message, isVisible, onClose, autoClose = false, uploadResponse = null }) => {
    const { theme } = useTheme();
    const CloseIcon = theme.name === 'light' ? CloseIconBlack : CloseIconWhite;

    React.useEffect(() => {
        if (isVisible && autoClose) {
            const timer = setTimeout(() => {
                onClose();
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [isVisible, onClose, autoClose]);

    const containerStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10000000,
        backgroundColor: theme.colors.overlay,
        backdropFilter: 'blur(5px)',
        WebkitBackdropFilter: 'blur(5px)',
        animation: 'fadeBackdrop 0.3s ease-in-out',
    };

    const popupStyle = {
        padding: '30px',
        backgroundColor: theme.colors.overlay,
        color: '#fff',
        borderRadius: '8px',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        animation: 'fadeIn 0.3s ease-in-out',
        position: 'relative',
        maxWidth: '450px',
    };

    const contentStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        margin: '10px 50px 10px 50px',
    };

    const resultBoxStyle = {
        marginTop: '15px',
        padding: '15px',
        backgroundColor: theme.name === 'light'
            ? 'rgba(0, 0, 0, 0.05)'
            : 'rgba(0, 0, 0, 0.3)',
        borderRadius: '5px',
        color: theme.colors.text,
        fontFamily: "Arial",
    };

    const closeIconStyle = {
        position: 'absolute',
        top: '10px',
        right: '10px',
        width: '20px',
        height: '20px',
        cursor: 'pointer',
    };

    const buttonStyle = {
        width: '80px',
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(message.split(' ').slice(-1)[0]);
    };

    const formatPercentage = (value) => {
        console.log(value);

        return (value * 100).toFixed(2) + '%';
    };

    if (!isVisible) return null;

    const modalContent = (
        <div style={containerStyle}>
            <style>
                {`
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(-20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes fadeBackdrop {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                `}
            </style>
            <div style={popupStyle}>
                <img
                    src={CloseIcon}
                    alt="Close"
                    style={closeIconStyle}
                    onClick={onClose}
                />
                <div style={contentStyle}>
                    <span style={{ color: theme.colors.text, fontFamily: "Arial" }}>{message}</span>
                    <Button onClick={copyToClipboard} style={buttonStyle}>Copy</Button>
                </div>

                {uploadResponse && (
                    <div style={resultBoxStyle}>
                        <p><strong>Upload Results:</strong></p>
                        <p>Samples added: {uploadResponse.samples.length}</p>
                        <p>Unmapped taxa: {formatPercentage(uploadResponse.unmapped_fraction)}</p>
                        {uploadResponse.unmapped_taxa && uploadResponse.unmapped_taxa.length > 0 && (
                            <div>
                                <p>Unmapped taxa list:</p>
                                <ul style={{ maxHeight: '100px', overflowY: 'auto', paddingLeft: '20px' }}>
                                    {uploadResponse.unmapped_taxa.map((taxon, index) => (
                                        <li key={index}>{taxon}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );

    return ReactDOM.createPortal(modalContent, document.body);
};

export default NotificationPopup;